import React, { useState } from 'react'
import {
  Box,
  Tabs,
  Tab,
  Alert
} from '@mui/material'
import {
  People as PeopleIcon,
  Business as BusinessIcon,
  Scanner as ScannerIcon,
  Badge as BadgeIcon,
} from '@mui/icons-material'
import { useAuth } from '../contexts/AuthContext'
import { PageHeader } from '../components/ui'

// Import componentele existente
import AdminUsersPage from './AdminUsersPage'
import InstitutionsListPage from './InstitutionsListPage'
import DevicesPage from './DevicesPage'
import StaffManagementPage from './StaffManagementPage'

// Styling compact pentru tab-uri (consistent cu restul aplicației)
const tabsSx = {
  minHeight: 36,
  '& .MuiTab-root': {
    minHeight: 36,
    py: 0.5,
    px: 1.5,
    fontSize: '0.78rem',
    textTransform: 'none',
    '& .MuiSvgIcon-root': {
      fontSize: '1rem',
      mr: 0.5
    }
  }
}

const ConfigurationPage: React.FC = () => {
  const { user } = useAuth()
  const [activeTab, setActiveTab] = useState<'institutii' | 'utilizatori' | 'angajati' | 'aparate'>('institutii')

  // Verifică permisiunile - doar admin și operator au acces
  if (!user || !['admin', 'operator'].includes(user.role)) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert 
          severity="error"
          sx={{ 
            bgcolor: 'error.dark', 
            color: 'error.contrastText',
            '& .MuiAlert-icon': { color: 'error.contrastText' },
            fontSize: '0.85rem'
          }}
        >
          Nu aveți permisiuni pentru a accesa această pagină.
        </Alert>
      </Box>
    )
  }

  // Tab-urile ca element pentru PageHeader
  const tabsElement = (
    <Tabs 
      value={activeTab} 
      onChange={(_, newValue) => setActiveTab(newValue)}
      sx={tabsSx}
    >
      <Tab
        icon={<BusinessIcon />}
        iconPosition="start"
        label="Instituții"
        value="institutii"
      />
      <Tab
        icon={<PeopleIcon />}
        iconPosition="start"
        label="Utilizatori"
        value="utilizatori"
      />
      <Tab
        icon={<BadgeIcon />}
        iconPosition="start"
        label="Angajați"
        value="angajati"
      />
      <Tab
        icon={<ScannerIcon />}
        iconPosition="start"
        label="Aparate"
        value="aparate"
      />
    </Tabs>
  )

  return (
    <Box>
      {/* Unified Page Header cu titlu și tab-uri */}
      <PageHeader
        title="Configurare"
        tabs={tabsElement}
      />

      {/* Content pentru tab-ul activ */}
      <Box sx={{ mt: 1 }}>
        {activeTab === 'institutii' && <InstitutionsListPage />}
        {activeTab === 'utilizatori' && <AdminUsersPage />}
        {activeTab === 'angajati' && <StaffManagementPage />}
        {activeTab === 'aparate' && <DevicesPage />}
      </Box>
    </Box>
  )
}

export default ConfigurationPage
